const faqs = [
  {
    q: '芭乐视频是否需要付费观看？',
    a: '芭乐视频完全免费。我们聚合红桃视频、樱花视频、糖豆视频等平台的公开内容，用户无需注册或付费即可浏览所有推荐资源。点击影片后会自动跳转至对应平台的播放页面，观看体验与直接访问平台一致。',
  },
  {
    q: '芭乐视频与红桃视频、樱花视频是什么关系？',
    a: '芭乐视频是独立的视频内容聚合导航平台，与红桃视频、樱花视频、糖豆视频等均无股权或运营关联。我们通过技术手段追踪和展示各平台的公开剧集信息，帮助用户在多个平台之间快速发现感兴趣的影视内容，属于信息聚合服务。',
  },
  {
    q: '平台上的视频更新速度如何？能否保证最新剧集同步？',
    a: '芭乐视频每日自动追踪各大平台的更新动态，通常能在内容上线后30分钟内完成同步。热门剧集、院线大片等均能保持与源平台的更新节奏一致。我们同时监控多个数据来源，确保时效性和准确性。',
  },
  {
    q: '播放时为什么会跳转到其他网站？如何获得最佳观看体验？',
    a: '芭乐视频不托管任何视频文件，点击影片后将跳转至源平台（红桃视频、樱花视频、糖豆视频等）的播放页面。建议在网络良好的环境下使用，各平台均支持高清画质。如果遇到播放卡顿，可尝试切换清晰度或刷新页面。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-xs font-semibold text-primary-600 uppercase tracking-wider">常见问答</span>
          <h2 className="mt-2 text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            常见问答
          </h2>
          <p className="mt-2 text-sm text-foreground-500">关于芭乐视频的常见问题与解答</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-100 border border-background-200/70 overflow-hidden"
            >
              <div className="p-5 md:p-6">
                <h3 className="flex items-start gap-3 text-sm md:text-base font-semibold text-foreground-900">
                  <span className="shrink-0 w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-xs font-bold mt-0.5">
                    Q
                  </span>
                  {faq.q}
                </h3>
                <p className="mt-3 pl-9 text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}